import { SIGN_IN, SIGN_ON } from '../../landingButtons.constants';

export const buttons = [SIGN_IN, SIGN_ON];
